/* eslint-disable max-len,no-unused-vars,no-undef,react/prop-types */
import React from 'react';
import { graphql, Link } from 'gatsby';
import { Sine, TimelineMax } from 'gsap';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import SEO from '../../components/seo';
import './style.scss';
import Layout from '../../components/Layout';
import NavBar from '../../components/NavBar';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import PodsBackground from '../../images/backgrounds/pods-background.png';
import PodsChart from '../../images/product-images/pods-chart.svg';
import ProductItem from '../../components/ProductItem';
import Footer from '../../components/Footer';
import getCloudinary from '../../utils/getCloudinary';
import getBrowserWidth from '../../utils/getBrowserWidth';

const buyNowRef = React.createRef();
// eslint-disable-next-line react/prop-types
const SkincarePage = ({ data, scrollPosition }) => (
    <Layout id="skincare-page">
        <SEO
            title="CBD Skincare - CBD Body Lotion & Face Cream - DR WATSON"
        />
        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content skincare-page">
            <div
                className="header-background"
            >
                <div className="header-background__content">
                    <div
                        className="header-background__content__info"
                    >
                        <div
                            className="title is-size-4-touch is-size-3-desktop has-text-centered-touch is-spaced"
                        >
CBD
                                Skincare
                        </div>
                        <div className="subtitle is-size-4-touch is-size-3-desktop has-text-centered-touch">
                                Swiss mountain water, Swiss Alps edelweiss, Swiss CBD extract and
                                jojoba oil. Allergen-free formula, no animal testing, GMP-certified
                                and 100% vegan.
                        </div>
                        <img
                            src={getCloudinary().url(
                                'rqwnnsoahmrjed4pmbkp',
                                { height: 240, crop: 'fit', fetch_format: 'auto' },
                            )}
                            alt="Pod"
                            className="pod-image is-hidden-desktop"
                        />
                        <button
                            type="button"
                            className="buy-now-button button is-theme-success has-text-white is-large"
                            onClick={() => {
                                // eslint-disable-next-line no-undef
                                window.scrollTo({
                                    top: buyNowRef.current.offsetTop,
                                    behavior: 'smooth',
                                });
                            }}
                        >
                                Buy Now
                        </button>
                        <div
                            className="title is-size-6-touch is-size-5-desktop why-buy-this-title is-spaced has-text-centered-touch"
                        >
                                Nourish and improve the appearance of your skin with the power of CBD.
                        </div>
                        <div className="subtitle is-size-6-touch is-size-5-desktop content">
                                DR WATSON beauty products are formulated in Switzerland using nutrient rich skin nourishing ingredients and hemp extracted CBD.
                            {/* <br /> */}
                            {/* <br /> */}
                            {/*    CBD is a powerful anti-oxidant and works on the CBD receptors within the dermis layers of the skin to promote healthy skin regeneration, collagen production, while helping to reduce signs of acne, aging, inflammation, redness and sunspots */}
                        </div>
                    </div>
                </div>
                <img
                    src={PodsBackground}
                    alt="Pods Curve"
                    style={{ marginTop: '-1px', width: '100%' }}
                />
            </div>

            <div className="content-below-header">
                <img
                    src={getCloudinary().url(
                        'rqwnnsoahmrjed4pmbkp',
                        { height: 640, crop: 'fit', fetch_format: 'auto' },
                    )}
                    alt="Pod"
                    className="pod-image is-hidden-touch"
                />
                <div
                    className="subtitle is-size-5-touch is-size-4-desktop container skincare-main-header"
                >
                     Keep your skin’s appearance in good condition with Dr Watson’s nourishing skincare products. A rich blend of natural oils, edelweiss, and CBD Dr Watson creams are manufactured to Swiss cosmetic standards and harness the power of cannabidiol to moisturize and cleanse your skin.

                    <br />
                    <br />

                     Our skincare products are designed for everyday use on normal to dry skin and are suitable for all skin types.
                    <br />
                    <br />
                     Cannabidiol is a hydrophobic molecule helping your skin retain its moisture and stay hydrated. Apply it to the face and body to support your skin’s natural hydration.

                </div>
                <div className="pod-chart-container">
                    <img
                        src={getCloudinary().url(
                            'dashboard-uploads/Lotion_banner_dosiaw',
                            { fetch_format: 'auto', crop: 'fit', width: parseInt(getBrowserWidth() * 1.2, 10) },
                        )}
                        className="skincare-banner"
                        alt="Applying DrWatson CBD Body Lotion"
                    />
                </div>
                <div className="products-list" ref={buyNowRef}>
                    <div className="container">
                        {/* <div */}
                        {/*    className="title is-size-3-touch is-size-2-desktop has-text-centered has-text-white" */}
                        {/* > */}
                        {/*        Rejuvenate, repair and soothe your skin */}
                        {/* </div> */}
                        <div className="columns is-multiline is-centered is-mobile is-marginless">
                            {
                                data.allStrapiProduct.edges.map(
                                    ({ node }) => node,
                                )
                                    .map(
                                        product => product.variants.map(
                                            variant => (
                                                <ProductItem
                                                    scrollPosition={scrollPosition}
                                                    product={{
                                                        ...product,
                                                        variant,
                                                    }}
                                                />
                                            ),
                                        ),
                                    )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </Layout>
);


export const query = graphql`
    query {
        allStrapiProduct (filter: {productgroup:{name:{eq: "Skincare"}}}){
            edges {
                node {
                    name
                    description
                    slug
                    productgroup {
                        id
                        name
                    }
                    variants {
                        id
                        name
                        description
                        price
                        wholesale_price
                        isFeatured
                        images {
                            createdAt
                            url
                            public_id
                        }
                    }
                }
            }
        }
    }
`;

export default trackWindowScroll(SkincarePage);
